import { useEffect } from "react";

export const useDocumentTitle = (title?: string) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    } else {
      document.title = "TheraPass - Therapy";
    }

    return () => {
      document.title = "TheraPass - Therapy Made Easy";
    };
  }, [title]);
};
